/**
 * Convierte un valor datetime-local ("YYYY-MM-DDTHH:MM") a ISO con offset
 * de la zona horaria del navegador, para que el backend interprete la hora correcta.
 */
export function localDateTimeToApi(localStr) {
  if (!localStr) return localStr;
  const d = new Date(localStr);
  if (Number.isNaN(d.getTime())) return localStr;

  const base = localStr.length === 16 ? `${localStr}:00` : localStr.slice(0, 19);
  const offsetMin = -d.getTimezoneOffset();
  const sign = offsetMin >= 0 ? "+" : "-";
  const abs = Math.abs(offsetMin);
  const oh = String(Math.floor(abs / 60)).padStart(2, "0");
  const om = String(abs % 60).padStart(2, "0");
  return `${base}${sign}${oh}:${om}`;
}

/** Parsea fechas/horas devueltas por la API (ISO con Z u offset). */
export function parseApiDateTime(value) {
  if (!value) return new Date();
  return new Date(value);
}
